import SeriesBreadcrumb from "./SeriesBreadcrumb";
import type { SeriesDetailsShow } from "../hooks/useSeriesDetails";
import { Skeleton } from "@/components/ui/skeleton";

const CLASS_NAME =
  "mx-auto flex max-w-md flex-col gap-6 px-4 pb-12 sm:max-w-5xl";

/**
 * A View all page of the series (SHO-757): breadcrumb, h1, then the page's
 * own grid. `SeriesSubPage.Skeleton` is its shape while the series loads.
 */
const SeriesSubPage: React.FC<{
  testId: string;
  show: SeriesDetailsShow;
  series: string;
  /** The breadcrumb's last crumb. */
  breadcrumb: string;
  title: string;
  children: React.ReactNode;
}> = ({ testId, show, series, breadcrumb, title, children }) => (
  <div data-test-id={testId} className={CLASS_NAME}>
    <SeriesBreadcrumb
      displayTitle={show.displayTitle}
      series={series}
      page={breadcrumb}
    />
    <h1 className="text-2xl font-semibold text-white">{title}</h1>
    {children}
  </div>
);

const SeriesSubPageSkeleton: React.FC<{
  testId: string;
  /** The title bar's width class, roughly the title's. */
  titleWidth: string;
  children: React.ReactNode;
}> = ({ testId, titleWidth, children }) => (
  <div data-test-id={testId} className={CLASS_NAME}>
    <div className="border-neutral-60 hidden border-b pb-4 sm:block">
      <Skeleton className="h-5.25 w-64" />
    </div>
    <Skeleton className={`h-7 ${titleWidth}`} />
    {children}
  </div>
);

export default Object.assign(SeriesSubPage, {
  Skeleton: SeriesSubPageSkeleton,
});
